import { render, staticRenderFns } from "./my_scholarships_data_tab.vue?vue&type=template&id=7e98b5f0"
import script from "./my_scholarships_data_tab.vue?vue&type=script&lang=js"
export * from "./my_scholarships_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports